import React, { useState } from "react";
import "../styles/About.css";
import aboutPic from "../assets/aboutPic.jpg";
import bg1 from "../assets/bg1.jpg";
import bg2 from "../assets/bg2.jpg";
import bg3 from "../assets/bg3.jpg";
import bg4 from "../assets/bg4.jpg";

const About = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleProfileClick = () => {
    setIsFlipped(true);
    setTimeout(() => setIsFlipped(false), 800); // duration matches the CSS animation
  };

  const bgImages = [bg1, bg2, bg3, bg4];

  // State: which sticker is mid-wiggle
  const [wiggling, setWiggling] = useState(Array(bgImages.length).fill(false));

  const handleBgClick = (idx) => {
    // Start wiggle
    setWiggling((prev) => {
      const copy = [...prev];
      copy[idx] = true;
      return copy;
    });

    // Stop wiggle after one animation cycle (500ms matches CSS duration)
    setTimeout(() => {
      setWiggling((prev) => {
        const copy = [...prev];
        copy[idx] = false;
        return copy;
      });
    }, 500);
  };

  return (
    <div className="about-container">
      <div className="background-images">
        {bgImages.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`decor-${i}`}
            className={`bg-image bg${i + 1} ${wiggling[i] ? "wiggle" : ""}`}
            onClick={() => handleBgClick(i)}
          />
        ))}
      </div>

      <div className="about-card">
        <img
          src={aboutPic}
          alt="Lilu smiling"
          className={`about-pic ${isFlipped ? "flip" : ""}`}
          onClick={handleProfileClick}
        />

        <div className="about-text">
          <h1>About Me ⋆</h1>
          <p>
            Hi! I'm currently a computer science student working toward my
            associates degree at community college, with plans to transfer in
            Fall 2026. I'm also working my way through school as a server,
            balancing work and study with dedication and efficiency.
          </p>
          <p>
            I moved out on my own at 16, and being the second oldest of eight
            siblings I've learned independence, teamwork, and resilience. What
            draws me to computer science is its perfect blend of logic,
            creativity, and problem-solving.
          </p>
          <p>
            I’ve always loved subjects like math, art, chemistry, and
            history—and CS brings them all together. I strive to be efficient,
            helpful, and kind, and I hope to build tools that help others,
            especially those with fewer resources, while creating a stable
            future for myself.
          </p>
          <p>
            My goal is to become a software engineer who creates meaningful and
            accessible technology, and to keep growing along the way ♡
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
